import React, { useState } from 'react';
import { Form } from 'antd';
import { useTranslation } from 'react-i18next';
import FormField from '../../../../../components/LookupForm/FormField';
import LookupFormLayout from '../../../../../components/LookupForm/LookupFormLayout';
import LookupCaptcha from '../../../../../components/LookupForm/LookupCaptcha';
import LookupSubmitButton from '../../../../../components/LookupForm/LookupSubmitButton';
import warrantyIllustration from '../../../../../assets/images/warranty-illustration.png';
import { useWarrantyLookupStore } from '../../../data/store';

// Page (presentation/index.js) sở hữu useWarrantyQuery() + điều hướng URL — form này chỉ nhận
// serial hợp lệ qua onSubmit, không tự gọi API, để tránh 2 instance state độc lập của cùng 1 lookup.
// `aside` là khối kết quả hiện ở cột phải; null thì cột phải hiện ảnh minh hoạ.
const WarrantyLookupForm = ({ onSubmit, loading, initialSerial, aside }) => {
  const { t } = useTranslation();

  const setHasVerifiedCaptcha = useWarrantyLookupStore((s) => s.setHasVerifiedCaptcha);

  const [serial, setSerialInput] = useState(initialSerial || '');

  const [form] = Form.useForm();

  const handleSubmit = () => {
    onSubmit(serial);
  };

  const handleCaptChaVerify = (token) => {
    if (token) {
      setHasVerifiedCaptcha(true);
    }
  };

  return (
    <Form form={form} onFinish={handleSubmit} initialValues={{ serial }}>
      <LookupFormLayout
        title={t('warrantyLookup.title')}
        note={t('warrantyLookup.note')}
        illustration={warrantyIllustration}
        illustrationAlt="warranty-illustration"
        aside={aside}
        equalColumns
      >
        <FormField
          label={t('warrantyLookup.serialLabel')}
          required
          name="serial"
          placeholder={t('warrantyLookup.serialPlaceholder')}
          value={serial}
          onChange={(e) => setSerialInput(e.target.value)}
          rules={[
            {
              required: true,
              message: t('warrantyLookup.validateBlankSerial'),
            },
          ]}
          hint={t('warrantyLookup.serialExample')}
        />
        <LookupCaptcha onVerify={handleCaptChaVerify} />

        <LookupSubmitButton loading={loading} />
      </LookupFormLayout>
    </Form>
  );
};

export default WarrantyLookupForm;
